import { ButtonBase, Icon, SxProps, Typography } from "@mui/material";

const style = {
    width: "100%",
    cursor: "pointer",
    bgcolor: "background.paper",
    display: "flex",
    alignItems: "center",
    px: 1.5,
    py: 1,
    borderRadius: "8px",
    border: "1px solid",
    borderColor: "divider",
    "&:hover": {
        bgcolor: "background.default",
    },
    transition: "background-color 0.2s",
};

export default function ActionButton(props: {
    title: string;
    icon: JSX.Element;
    sx?: SxProps;
    onClick: () => void;
}) {
    return (
        <ButtonBase onClick={props.onClick} sx={{ ...style, ...props.sx }}>
            {props.icon}

            <Typography
                fontSize="smaller"
                sx={{ flexGrow: 1, ml: 1 }}
                color="text.secondary"
            >
                {props.title}
            </Typography>

            <Icon color="primary">chevron_left</Icon>
        </ButtonBase>
    );
}
